import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Temperatura, temperaturas } from '../temperatura';

@Component({
    selector: 'sgt-temperatura-select',
    templateUrl: './temperatura-select.component.html',
    styleUrls: ['./temperatura-select.component.less']
})
export class TemperaturaSelectComponent implements OnInit {
    temperaturas = temperaturas;

    /** Temperatura */
    @Input() idTemperatura: number;
    /** Ao alterar a temperatura */
    @Output() idTemperaturaChange = new EventEmitter<number>();
    /** Temperatura selecionada */
    temperatura: Temperatura;
    /** Temperatura alterada */
    @Output() temperaturaChange = new EventEmitter<Temperatura>();

    /** Tamanho do avatar */
    @Input() imageSize = '20px';
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;

    ngOnInit(): void {
        this.temperatura = this.temperaturas.find(temperaturaFilter => temperaturaFilter.id == this.idTemperatura);
    }

    /** Ao selecionar a temperatura */
    select(temperatura: Temperatura) {
        this.idTemperatura = temperatura ? temperatura.id : null;
        this.idTemperaturaChange.emit(this.idTemperatura);
        this.temperatura = temperatura;
        this.temperaturaChange.emit(this.temperatura)
    }
}
